import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { space6 } = theme();
    return StyleSheet.create({
        summary: {
            paddingTop: space6,
        },
    });
};
export { style };
